// extracted by mini-css-extract-plugin
export default {"editUserRoot":"EditUser_editUserRoot__-q2Sa"};